<template lang="pug">
    v-card(style="height: 600px;")
      v-card-title.dialog-card-title
        p Mesa {{currentTable.index}}
        v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
      v-card-content.table-detail-content
          v-data-table(v-if="currentTable.items && currentTable.items.length > 0" :headers='headers', :items='currentTable.items')
              template.pa-3(v-slot:item.pictures="{ item }")
                  v-img(v-if='item.pictures && item.pictures.imageInput1' contain width="100" height="100" :src="item.pictures.imageInput1")
                  v-img(v-else src="https://via.placeholder.com/150")
              template(v-slot:item.status="{ item }")
                  p {{item.status | translateStatus}}
</template>

<script>
  export default {

    filters: {
      translateStatus (status) {
        let newStatus
        switch (status) {
          case 'pending':
            newStatus = 'Pendiente por cocina'
            break
          case 'ready':
            newStatus = 'Listo a entregar'
            break
          case 'served':
            newStatus = 'Entregado al cliente'
            break
        }
        return newStatus
      },
    },
    props: {
      currentTable: {
        type: Object,
        default: () => {},
      },
    },

    computed: {
      headers () {
        return [
          {
            text: 'Imagen',
            value: 'pictures',
            align: 'center',
          },
          {
            text: 'Cantidad',
            value: 'amount',
            align: 'center',
          },
          {
            text: 'Nombre',
            value: 'name',
            align: 'center',
          },
          {
            text: 'Estatus',
            value: 'status',
            align: 'center',
          },
        ]
      },
    },
  }
</script>

<style lang="scss" scoped>
    .table-detail-content{
        height: 250px !important;
        overflow-y: scroll;
    }
</style>
